export default __webpack_public_path__ + "static/media/bd.72b8bf86.svg";